module.exports = __webpack_public_path__ + "static/media/mobito-icon.fd8811a8.svg";